// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Bo-z","imageAndVideoCount":"Co-z","imageAndVideoContainer":"Do-z","viewAllReviews":"Eo-z"};